export default "__VITE_ASSET__1d940a79__"